import { ComponentStyleConfig } from '@chakra-ui/react';

export const Container: ComponentStyleConfig = {
  baseStyle: {
    boxSizing: 'border-box',
    px: {
      base: 4,
      sm: 0,
    },
  },
};
